export default __webpack_public_path__ + "static/media/H1007.3.8c870cf8.mp3";